import Model, { attr } from '@ember-data/model';

export default class ClientStatementAccountDetailModel extends Model {
  @attr('string') additionalLines!: string;
  @attr('string') addressCity!: string;
  @attr('string') addressCountry!: string;
  @attr('string') addressStreet!: string;
  @attr('string') addressSuite!: string;
  @attr('string') addressZipCode!: string;
  @attr('string') businessName!: string;
  @attr('string') logoUrl!: string;
  @attr('string') s3LogoUrl!: string | null;
  @attr('string') taxNumber!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'client-statement-account-detail': ClientStatementAccountDetailModel;
  }
}
